module.exports = __webpack_public_path__ + "img/tidal.bcbc378c.svg";